import api from "@/services/api";

export default {
  fetchResponses() {
    return api.get(`responseJSON/`);
  },
  postResponses(payload) {
    return api.post(`responseJSON/`, payload).then(response => response.data);
  },
  getStakeholderResponses(payload) {
    return api.get(
      `responseJSON/get_stakeholder_responses/?pk=${payload.pk}`,
      payload
    );
  }
};
